import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../services/axois";
import { toast } from "react-toastify";
// this is for demo purpose only / change for further api calls


export const getInventory = createAsyncThunk(
  "inventory/getInventory",
  async () => {
    try {
      let url = `/material`;
      const response = await apiClient.get(url);
      return response?.data?.result; // todo: need to store only "result" array inside redux state
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const addInventory = createAsyncThunk(
  "inventory/addInventory",
  async (data,{ dispatch }) => {
    const inventoryData = {
      materialName: data.materialName,
      quantity: data.quantity,
    }
    try {
      let url = `/material`;
      const response = await apiClient.post(url, inventoryData);
      dispatch(getInventory())

      if (response.status) {
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);

      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })

      throw error;
    }
  }
);


export const mangeInventory = createAsyncThunk(
  "inventory/mangeInventory",
  async (data,{ dispatch }) => {

    const branchId = data.branchName;

    const mangeInventoryData = {
      materialId: data.materialId,
      branchMaterialQuantity: data.branchMaterialQuantity
    }
    try {
      let url = `branch/material/${branchId}`;
      const response = await apiClient.post(url, mangeInventoryData);
      dispatch(getInventory())
      if (response.status) {
        toast.success(response.data.message, {
          // progressStyle: { background: '#428D56' },
       })
      }
    } catch (error) {
      console.error("builder function error:", error);
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })
      throw error;
    }
  }
);

export const editInventory = createAsyncThunk(
  "inventory/editInventory",
  async (data,{ dispatch }) => {


    const materialId = data.materialId;

    const editedInventoryData = {
      materialName: data.materialName,
      quantity: data.branchMaterialQuantity,
    }
    try {
      let url = `material/${materialId}`;
      const response = await apiClient.put(url, editedInventoryData);
      if (response.status) {
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          // progressStyle: { background: '#ffffff' },
        })
      }
      dispatch(getInventory())
    } catch (error) {
      console.error("builder function error:", error);
      toast.error(error.response.data.message, {
        className: 'custom-toast-error',
        // progressStyle: { background: '#C53C43' },
      })
      throw error;
    }
  }
);


export const getInventoryHistory = createAsyncThunk(
  "inventory/getInventoryHistory",
  async (materialId) => {
    try {
      let url = `/material/${materialId}`;
      const response = await apiClient.get(url);
      return response?.data?.result; // todo: need to store only "result" array inside redux state
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);




